import { PDFDocument } from 'pdf-lib';

// Compresses a pdf to a smaller size
export const compressPDF = async (pdfBlob) => {
  try {
    const pdfDoc = await PDFDocument.load(await pdfBlob.arrayBuffer());
    // // Optionally, remove unused objects or compress the document
    // pdfDoc.setCreator('Your App Name');
    // pdfDoc.setProducer('Your App Name');

    // Save the compressed PDF
    const compressedPdfBytes = await pdfDoc.save({ useObjectStreams: true });
    const compressedPdfBlob = new Blob([compressedPdfBytes], {
      type: 'application/pdf',
    });

    return compressedPdfBlob;
  } catch (err) {
    console.error('Error compressing PDF:', err);
    throw err;
  }
};
